import { useDispatch, useSelector } from "react-redux";

import { ManualSelectionItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { useTableSelections } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useTableSelections";
import {
    selectFilteredCompetitorsDomains,
    selectSelectedCompetitorsDomains,
} from "app/pages/sales-intelligence/modules/company-analysis/store/competitors/selectors";
import saveToListSelectionDropdown from "app/pages/sales-intelligence/sub-modules/opportunities/models/save-to-list-selection/saveToListSelectionDropdown";
import { updateListOpportunitiesWithSuccessModalThunk } from "app/pages/sales-intelligence/sub-modules/opportunities/store/effects";
import trackingService from "app/pages/sales-intelligence/services/tracking/createMultiSelectorPanelService";
import SaveToListPanel from "app/pages/sales-intelligence/sub-modules/opportunities/components/table-actions-panel/SaveToListPanel/SaveToListPanel";
import { useFetchOpportunityListsIfNotPresent } from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useFetchOpportunityListsIfNotPresent";
import useTrackedWebsitesQuota from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useTrackedWebsitesQuota";
import useUntrackedDomainsCount from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useUntrackedDomainsCount";
import {
    selectOpportunityListCreating,
    selectOpportunityListUpdating,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type { OpportunityListType } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/BaseActivatedPanel/types";
import type { SelectionDropdownItem } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown-item/types";

export const SaveToListCompetitorsPanel = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();
    const { remaining } = useTrackedWebsitesQuota();
    const isListCreateInProgress = useSelector(selectOpportunityListCreating);
    const isListUpdateInProgress = useSelector(selectOpportunityListUpdating);
    const selectedCompetitorsDomains = useSelector(selectSelectedCompetitorsDomains);
    const filteredCompetitorsDomains = useSelector(selectFilteredCompetitorsDomains);
    const numberOfUntrackedSelectedDomains = useUntrackedDomainsCount(selectedCompetitorsDomains);

    useFetchOpportunityListsIfNotPresent();

    const { clearAndCloseRowsSelection, onSelectionChange } = useTableSelections();

    const handleDeactivate = () => {
        clearAndCloseRowsSelection();
        props.onDeactivate();
    };

    const handleSubmit = async (
        list: Readonly<OpportunityListType>,
        selectionItem: Readonly<SelectionDropdownItem>,
    ) => {
        trackingService.trackMultiSelectorSaveToListClick(remaining, selectionItem);

        const dto = {
            opportunities:
                selectionItem.id === ManualSelectionItem.ID
                    ? selectedCompetitorsDomains
                    : filteredCompetitorsDomains.slice(0, selectionItem.value),
        };
        await dispatch(updateListOpportunitiesWithSuccessModalThunk(list, dto));

        return handleDeactivate();
    };

    return (
        <SaveToListPanel
            isSubmitInProgress={isListCreateInProgress || isListUpdateInProgress}
            numberOfRemainingItems={remaining}
            numberOfResults={filteredCompetitorsDomains.length}
            numberOfSelectedItems={selectedCompetitorsDomains.length}
            numberOfUntrackedSelectedItems={numberOfUntrackedSelectedDomains}
            selectionDropdown={saveToListSelectionDropdown}
            onDeactivate={handleDeactivate}
            onSelectionChange={onSelectionChange}
            onSubmit={handleSubmit}
        />
    );
};
